export enum BookingAttemptErrorType {
    Unknown = 'Unknown'
}

export class BookingAttemptError extends Error {
    type: BookingAttemptErrorType;

    constructor(type: BookingAttemptErrorType, message?: string) {
        super(message ?? BookingAttemptErrorMessages[type]);

        this.type = type;
    }
}

export const BookingAttemptErrorMessages: Record<BookingAttemptErrorType, string> = {
    [BookingAttemptErrorType.Unknown]: 'Oops, something went wrong.'
};
